module.exports = "/_next/static/images/debae56c9d435aa86986f814c04c8d79-telcel-icon.svg.webp";